module.exports = __webpack_public_path__ + "static/liz-and-puddle-1-ecf3ca88c4deed6005ce37d6c8c86c61.png";